import axios from 'axios';

axios.defaults.withCredentials = true;

export interface LoginResult {
    status: LoginStatus;
    uri: string | null;
}

export enum LoginStatus {
    Success,
    OTP,
    Failure,
}

export const userSignIn = async (username: string, password: string): Promise<LoginResult> => {
    try {
        const res = await axios.post(`${API_BASE}/api/session`, {
            username: username,
            password: password,
        });

        if ('uri' in res.data) {
            const optResult = {
                status: LoginStatus.OTP,
                uri: res.data.uri,
            }

            return optResult;
        }

        const successResult = {
            status: LoginStatus.Success,
            uri: null,
        }

        return successResult;
    } catch (err) {
        const failureResult = {
            status: LoginStatus.Failure,
            uri: null,
        }

        return failureResult;
    }
};
